import { render, staticRenderFns } from "./mrchantIndex.vue?vue&type=template&id=2e17b90c&scoped=true&"
import script from "./mrchantIndex.vue?vue&type=script&lang=js&"
export * from "./mrchantIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e17b90c",
  null
  
)

export default component.exports